cockpitApp.directive('flightBodyTitle', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/flight/body/title',
    controller: 'flightTitleController',
    controllerAs: 'flightTitleCtrl'
  };
});
